import { Controller } from "@hotwired/stimulus"

import Cookies from 'js-cookie'

// Connects to data-controller="hook"
export default class extends Controller {
  static values = {
    path: String
  }

  connect() {
    setInterval(() => {
      fetch(this.pathValue, { signal: AbortSignal.timeout(2000) }).then(response => response.json()).then(data => {

        if (data.state == 'hooked') window.location.href = data.path;
      });
    }, 3000)
  }
}
